import { useState } from "react";


import BusinessTypeStep from "../../components/providerRegistration/BusinessTypeStep/BusinessTypeStep";
import OwnerDetailsStep from "../../components/providerRegistration/OwnerDetailsStep/OwnerDetailsStep";


import AddressStep from "../../components/providerRegistration/AddressStep/AddressStep";
import FoodBusinessInfo from "../../components/providerRegistration/BusinessInfo/FoodBusinessInfo";

import BakeryBusinessInfo from "../../components/providerRegistration/BusinessInfo/BakeryBusinessInfo";

import CateringBusinessInfo from "../../components/providerRegistration/BusinessInfo/CateringBusinessInfo";

import ProvisionBusinessInfo from "../../components/providerRegistration/BusinessInfo/ProvisionBusinessInfo";
import BankDetailsStep from "../../components/providerRegistration/BankDetailsStep/BankDetailsStep";

import ReviewStep from "../../components/providerRegistration/ReviewStep/ReviewStep";
import TermsConditionsStep from "../../components/providerRegistration/TermsConditionsStep/TermsConditionsStep";
import ApplicationSubmittedStep from "../../components/providerRegistration/ApplicationSubmittedStep/ApplicationSubmittedStep";




import "./ProviderRegister.css";

function ProviderRegister() {

    const [step, setStep] = useState(1);
    const [providerId, setProviderId] = useState("");

    const [providerData, setProviderData] = useState({

  providerType: "",

  owner: {

    name: "",

    phone: "",

    email: "",

    gender: "",

    verified: false,

  },

business: {

    businessName: "",

    description: "",

    openingHour: "",
    openingMinute: "",
    openingPeriod: "",

    closingHour: "",
    closingMinute: "",
    closingPeriod: "",

    experience: "",

    foodType: "",

    hasGST: "",
    gstNumber: "",

    hasFSSAI: "",
    fssaiNumber: "",

    deliveryRadius: "",

    minimumOrder: "",

    maximumGuests: "",

    priceRange: "",

    weeklyHoliday: "",

    cuisines: [],

    categories: [],

    eventTypes: [],

    services: []

},

  address: {

    address: "",

    landmark: "",

    area: "",

    city: "",

    state: "",

    pincode: "",

    latitude: "",

    longitude: "",

    deliveryRadius: 5

  },

  documents: {

    aadhaar: "",

    pan: ""

  },

  images: {

    profile: "",

    cover: "",

    business: [],

    food: []

  },

 bank: {
    accountHolder: "",
    bankName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifscCode: "",
    upiId: "",
    accountType: "Savings",
    isVerified: false,
},

  

 

  

});

    const nextStep = (id = null) => {
    if (id) {
        setProviderId(id);
    }

    setStep((prev) => prev + 1);
};

    const previousStep = () => {

        setStep((prev) => prev - 1);

    };

    return (

        <div className="provider-register-page">

            <div className="provider-register-card">

                <div className="provider-header">

                    <img
                        src="/images/logo.png"
                        alt="HomeFoods"
                    />

                    <h1>Become a Provider</h1>

                    <p>

                        Start your business journey with HomeFoods

                    </p>

                </div>

               

                {step === 1 && (

                    <BusinessTypeStep

                        providerData={providerData}

                        setProviderData={setProviderData}

                        nextStep={nextStep}

                    />

                )}

     {step === 2 && (
    <OwnerDetailsStep
        providerData={providerData}
        setProviderData={setProviderData}
        nextStep={nextStep}
        previousStep={previousStep}
    />
)}





{step === 4 && (
  <AddressStep
    providerData={providerData}
    setProviderData={setProviderData}
    nextStep={nextStep}
    previousStep={previousStep}
  />
)}

{step === 3 && (

    <>

        {(providerData.providerType === "Home Chef" ||

          providerData.providerType === "Restaurant" ||

          providerData.providerType === "Hotel") && (

            <FoodBusinessInfo

                providerData={providerData}

                setProviderData={setProviderData}

                nextStep={nextStep}

                previousStep={previousStep}

            />

        )}

        {providerData.providerType === "Bakery" && (

            <BakeryBusinessInfo

                providerData={providerData}

                setProviderData={setProviderData}

                nextStep={nextStep}

                previousStep={previousStep}

            />

        )}

        {providerData.providerType === "Catering" && (

            <CateringBusinessInfo

                providerData={providerData}

                setProviderData={setProviderData}

                nextStep={nextStep}

                previousStep={previousStep}

            />

        )}

        {providerData.providerType === "Provision Store" && (

            <ProvisionBusinessInfo

                providerData={providerData}

                setProviderData={setProviderData}

                nextStep={nextStep}

                previousStep={previousStep}

            />

        )}

    </>

)}

{step === 5 && (

    <BankDetailsStep

        providerData={providerData}

        setProviderData={setProviderData}

        nextStep={nextStep}

        previousStep={previousStep}

    />

)}


{step === 6 && (
   <ReviewStep
    providerData={providerData}
    previousStep={previousStep}
    nextStep={nextStep}
/>
)}

{step === 7 && (
    <TermsConditionsStep
        providerData={providerData}
        setProviderData={setProviderData}
        nextStep={nextStep}
        previousStep={previousStep}
    />
)}

{step === 8 && (
    <ApplicationSubmittedStep
        providerData={providerData}
        providerId={providerId}
    />
)}

            </div>

        </div>

    );

}

export default ProviderRegister;